import type { AttendanceStatus, GroupJournal } from '../../../../shared/src/types/api'

export const statusLabels: Record<AttendanceStatus, string> = {
  present: 'Был', absent: 'Не был', late: 'Опоздал', left_early: 'Ушёл раньше', sick: 'Болеет', excused: 'Уважительная причина',
}
export const statuses = Object.keys(statusLabels) as AttendanceStatus[]
export const attended = (status?: AttendanceStatus) => status === 'present' || status === 'late' || status === 'left_early'
export const dateOnly = (value: string) => value.slice(0, 10)
export const timeOnly = (value?: string) => value?.match(/(?:T|^)(\d{2}:\d{2})/)?.[1] || ''
export function localDate(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}
export function nextDate(value: string) {
  const date = new Date(`${value}T12:00:00`)
  date.setDate(date.getDate() + 1)
  return localDate(date)
}
export function monthRange() {
  const now = new Date()
  return { from: localDate(new Date(now.getFullYear(), now.getMonth(), 1)), to: localDate(now) }
}
export function periodError(from: string, to: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(from) || !/^\d{4}-\d{2}-\d{2}$/.test(to)) return 'Выберите начало и конец периода'
  const span = (Date.parse(to) - Date.parse(from)) / 86400000
  if (!Number.isFinite(span) || span < 0) return 'Конец периода должен быть не раньше начала'
  if (span > 92) return 'Выберите период не длиннее 93 дней'
  return ''
}
export function errorText(error: unknown) {
  const detail = error as { user_message?: string; error?: string; message?: string }
  return detail?.user_message || detail?.error || detail?.message || 'Не удалось загрузить данные. Повторите попытку.'
}
export const rateLabel = (value: number | null) => value === null ? 'Нет отметок' : `${Math.round(value)}%`

/** Compute from explicit marks only; cancelled sessions never enter the denominator. */
export function journalMetrics(journal: GroupJournal) {
  const sessions = (journal.sessions || []).filter(session => !session.cancelled)
  const rows = (journal.rows || []).map(row => {
    const marks = sessions.map(session => row.marks?.[session.session_id]).filter((status): status is AttendanceStatus => !!status)
    const present = marks.filter(attended).length
    return { athleteId: row.athlete_id, name: row.name, present, marked: marks.length,
      unmarked: sessions.length - marks.length, rate: marks.length ? present / marks.length * 100 : null }
  })
  const trend = sessions.map(session => {
    const marks = (journal.rows || []).map(row => row.marks?.[session.session_id]).filter((status): status is AttendanceStatus => !!status)
    const present = marks.filter(attended).length
    return { id: session.session_id, date: dateOnly(session.date), time: timeOnly(session.start_time),
      present, marked: marks.length, rate: marks.length ? present / marks.length * 100 : null }
  })
  const marked = rows.reduce((sum, row) => sum + row.marked, 0)
  const present = rows.reduce((sum, row) => sum + row.present, 0)
  return { rows, trend, marked, present, held: sessions.length,
    cancelled: (journal.sessions || []).length - sessions.length,
    unmarked: rows.reduce((sum, row) => sum + row.unmarked, 0),
    rate: marked ? present / marked * 100 : null }
}
